import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
	AufgabenTyp,
	AufgabeTypLabel,
	aufgabeVersandTaetigkeiten,
	AufgabeVersandTaetigkeitLabel,
} from '@schir-int-client/aufgabe-shared';
import { KontaktKategorie, KontaktKategorieLabel, kontaktKategorien } from '@schir-int-client/adressverwaltung-shared';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';

import { CheckboxesComponent } from '../../../../../../tech/src/lib/checkboxes/checkboxes.component';
import { TechModule } from '@schir-int-client/tech';
import { CreateVerfuegungFormService } from '../create-verfuegung.formservice';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'schir-int-client-bescheinigung-editor',
	templateUrl: './bescheinigung-editor.component.html',
	styleUrls: ['./bescheinigung-editor.component.scss'],
	imports: [MatRadioModule, MatCheckboxModule, ReactiveFormsModule, MatInputModule, CheckboxesComponent, TechModule],
})
export class BescheinigungEditorComponent {
	private readonly verfuegungFormService = inject(CreateVerfuegungFormService);
	private readonly aufgabeFormService = inject(CreateAufgabeFormService);
	protected readonly formGroup = this.verfuegungFormService.bescheinigungGroup;

	protected toggleFaxEmpfaengerControl(enable: boolean) {
		enable ? this.formGroup.controls.faxEmpfaenger.enable() : this.formGroup.controls.faxEmpfaenger.disable();
	}

	readonly bescheinigungsarten: (
		| AufgabenTyp.HYPOTHEKENBESCHEINIGUNG
		| AufgabenTyp.EIGENTUEMERBESCHEINIGUNG
		| AufgabenTyp.LOESCHUNGSBESCHEINIGUNG
		| AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG
		| AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG
	)[] = [
		AufgabenTyp.HYPOTHEKENBESCHEINIGUNG,
		AufgabenTyp.EIGENTUEMERBESCHEINIGUNG,
		AufgabenTyp.LOESCHUNGSBESCHEINIGUNG,
		AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG,
		AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG,
	];
	readonly aufgabeTypLabel = AufgabeTypLabel;
	readonly versandTaetigkeiten = aufgabeVersandTaetigkeiten;
	readonly versandTaetigkeitLabel = AufgabeVersandTaetigkeitLabel;

	protected readonly kontaktKategorien = kontaktKategorien.filter(
		value => value !== KontaktKategorie.EINGETRAGENER_EIGENTUEMER
	);
	protected readonly kontaktKategorieLabel = this.kontaktKategorien.reduce(
		(acc, key) => ({ ...acc, [key]: KontaktKategorieLabel[key] }),
		{} as Partial<typeof KontaktKategorieLabel>
	);

	constructor() {
		this.formGroup.valueChanges.pipe(takeUntilDestroyed()).subscribe(v => {
			for (const bescheinigungsart of this.bescheinigungsarten) {
				const fg = this.aufgabeFormService.form.controls[bescheinigungsart];
				if (v.bescheinigungsart.includes(bescheinigungsart)) {
					fg.enable();
					if (!fg.controls.body.controls.vorabPerFax.value) {
						fg.controls.body.controls.faxEmpfaenger.disable();
					}
					fg.setValue({
						body: {
							taetigkeit: v.versandTaetigkeit,
							empfaenger: v.empfaenger,
							vorabPerFax: v.vorabPerFax,
							faxEmpfaenger: v.faxEmpfaenger ?? [],
						},
						notiz: v.notiz,
					});
				} else {
					fg.disable();
				}
			}
		});
	}
}
